import * as React from "react";
import classNames from "clsx";
import { Slot } from "@radix-ui/react-slot";

export type ColumnSpan = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
type GridItemElement = React.ElementRef<"div">;
type GridItemProps = React.ComponentPropsWithoutRef<"div"> & {
  asChild?: boolean;
  // prettier-ignore
  spanLarge: ColumnSpan;
  // prettier-ignore
  offsetLarge?:  ColumnSpan;
  // prettier-ignore
  spanMedium: ColumnSpan;
  // prettier-ignore
  offsetMedium?: ColumnSpan;
  spanSmall: 1 | 2 | 3 | 4;
  offsetSmall?: 1 | 2 | 3 | 4;
  hideOnSmall?: boolean;
  hideOnMedium?: boolean;
  hideOnLarge?: boolean;
};

const GridItem = React.forwardRef<GridItemElement, GridItemProps>(
  (props, forwardedRef) => {
    const {
      className,
      asChild,
      spanLarge,
      offsetLarge,
      spanMedium,
      offsetMedium,
      spanSmall,
      offsetSmall,
      hideOnLarge,
      hideOnSmall,
      hideOnMedium,
      style: propStyle,
      ...gridProps
    } = props;
    const Comp = asChild ? Slot : "div";

    let style: React.CSSProperties | Record<string, string | undefined> = {
      ...propStyle,
    };

    style = {
      "--grid-span-l": offsetLarge
        ? `${spanLarge} / ${offsetLarge + spanLarge + 1}`
        : `${spanLarge}`,
      "--grid-span-m": offsetMedium
        ? `${spanMedium} / ${offsetMedium + spanMedium + 1}`
        : `${spanMedium}`,
      "--grid-span-s": offsetSmall
        ? `${spanSmall} / ${offsetSmall + spanSmall + 1}`
        : `${spanSmall}`,
      ...style,
    };

    return (
      <Comp
        {...gridProps}
        ref={forwardedRef}
        className={classNames("in-grid-item", hideOnLarge && "in-grid-item__l--hide", hideOnMedium && "in-grid-item__m--hide", hideOnSmall && "in-grid-item__s--hide", className)}
        style={Object.keys(style).length ? style : undefined}
      />
    );
  }
);
GridItem.displayName = "GridItem";

export { GridItem };
export type { GridItemProps };
